import React, { useState } from "react";
import { Button, useNotify, useRefresh, useRecordContext, usePermissions, useTranslate } from "react-admin";
import CheckIcon from "@material-ui/icons/Check";
import BlockIcon from "@material-ui/icons/Block";
import { Box, Typography } from "@material-ui/core";

import { httpClient } from "api/httpClient";
import { UserRole } from "entities/UserRole";
import { ThirdPartyAppStatus, ThirdPartyAppStatusName } from "entities/ThirdPartyAppStatus";
import { useNotifyError } from "utils/notifiers/useNotifyError";


export const ThirdPartyAppStatusActions = (props) => {
	const record = useRecordContext(props);
	const { permissions } = usePermissions();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const refresh = useRefresh();
	const translate = useTranslate();
	const [loading, setLoading] = useState(false);

	if (!record || !permissions || permissions.role !== UserRole.admin) return null;

	const setStatus = async (status) => {
		setLoading(true);
		try {
			await httpClient(`/third-party-apps/${record.id}`, {
				method: "PATCH",
				body: JSON.stringify({ status: status }),
			});
			notify("osfc.notification.third_party_app_status_updated", "info");
			refresh();
		} catch (error) {
			notifyError(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Box display="flex" alignItems="center" gridGap={8} marginLeft="auto">
			<Typography variant="body2">
				{translate("resources.third-party-apps.fields.status")}:{" "}
				{translate(`osfc.enums.third_party_app.status.${ThirdPartyAppStatusName[record.status]}`)}
			</Typography>
			<Button
				label="osfc.buttons.approve"
				onClick={() => setStatus(ThirdPartyAppStatus.published)}
				disabled={loading || record.status === ThirdPartyAppStatus.published}
			>
				<CheckIcon />
			</Button>
			<Button
				label="osfc.buttons.reject"
				onClick={() => setStatus(ThirdPartyAppStatus.rejected)}
				disabled={loading || record.status === ThirdPartyAppStatus.rejected}
			>
				<BlockIcon />
			</Button>
		</Box>
	);
};
